const APPILY_TYPE = {
  APPILY: 'appily_authentication',
  APPILY_IFRAME: 'appily_authentication_iframe',
  APPILY_FORM: 'appily',
};

export default APPILY_TYPE;
